"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReceiptHTMLV2 = exports.getCustomReceiptHeader = void 0;
const moment_1 = __importDefault(require("moment"));
const homi_shared_1 = require("@getgreenline/homi-shared");
const utils_1 = require("./utils");
const receiptLoyalty_1 = require("./receiptLoyalty");
const receiptLoyaltyHtml_1 = require("./receiptLoyaltyHtml");
const lodash_1 = require("lodash");
const models_1 = require("../models");
const getCustomReceiptHeader = (receiptSettings, companyName, locationName) => {
    switch (receiptSettings.headerOption) {
        case models_1.RECEIPT_HEADER_OPTIONS.USE_CUSTOM:
            return receiptSettings.header || '';
        case models_1.RECEIPT_HEADER_OPTIONS.USE_LOCATION_NAME:
            return locationName || '';
        default:
            return companyName || '';
    }
};
exports.getCustomReceiptHeader = getCustomReceiptHeader;
// NOTE: This is using the new receipt settings
const generateReceiptHTMLV2 = ({ company, payment, fontSize, loyaltyData, receiptLoyalty, receiptSettings, paymentOptionNames, showPaidTag, paymentFeeProducts, }) => {
    const { subHeader, description, address, footer, showEmployee, showSku } = receiptSettings;
    const cashTransactionsTotal = (0, homi_shared_1.parseTotalTransactionsById)(homi_shared_1.PaymentTypeIds.cash, payment.transactions);
    const change = payment.tendered - cashTransactionsTotal;
    const totalDepositFee = payment.paymentLines.reduce((a, pl) => (pl.depositFee || 0) + a, 0);
    const isRefundPayment = (0, receiptLoyalty_1.isRefundReceipt)(payment, loyaltyData, receiptLoyalty);
    const headerText = (0, exports.getCustomReceiptHeader)(receiptSettings, company.name, payment.locationName);
    const paymentLinesWithoutPaymentFees = payment.paymentLines.filter((pl) => !(paymentFeeProducts || []).find((pf) => pf.id === pl.productId));
    const paymentFeeLines = payment.paymentLines.filter((pl) => (paymentFeeProducts || []).find((pf) => pf.id === pl.productId));
    return `
  <div id='print-section' style='padding-left: 10px; padding-right: 10px;'>
    <table style='width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
      <tbody>
        <tr style='font-size: 1.5em; text-align:center; width: 100%'>
          <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; font-weight: bold; word-break: break-word'>${headerText}</td>
        </tr>
        ${subHeader
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word; font-weight: bold'>${subHeader}</td>
          </tr>
          `
        : ''}
        ${description
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${description}</td>
          </tr>
          `
        : ''}
        ${address
        ? `
          <tr style='text-align:center;'>
            <td colspan=2 style='white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${address}</td>
          </tr>
          `
        : ''}
      </tbody>
    </table>

    <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
      <tbody>
        ${showPaidTag
        ? `
            <tr>
              <td colspan=2 style='padding-bottom: 0.5rem; font-size: 1.2em; text-align: right'><b>PAID</b></td>
            </tr>
            `
        : ''}
        ${payment.customId
        ? `<tr>
              <td style='border-top: solid; border-width: 1px; '>Sale ID</td>
              <td style='border-top: solid; border-width: 1px;  text-align: right'>${payment.customId}</td>
            </tr>`
        : ''}
        ${payment.completeDate
        ? `
            <tr>
              <td style='border-top: solid; border-width: 1px; '>Completed</td>
              <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, moment_1.default)(payment.completeDate).format('lll')}</td>
            </tr>
            `
        : `
            <tr>
              <td style='border-top: solid; border-width: 1px; '>Created</td>
              <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, moment_1.default)(payment.createDate).format('lll')}</td>
            </tr>
            `}
        <tr>
          <td style='border-top: solid; border-width: 1px; '>POS</td>
          <td style='border-top: solid; border-width: 1px;  text-align: right'>${payment.deviceName || '-'}</td>
       </tr>
        ${showEmployee
        ? `
              <tr>
                <td style='border-top: solid; border-width: 1px; '>Employee</td>
                <td style='border-top: solid; border-width: 1px;  text-align: right'>${(payment.employeeName || '').split(' ')[0]}</td>
              </tr>
            `
        : ''}
        ${payment.customerName
        ? `
              <tr>
                <td style='border-top: solid; border-width: 1px; '>Customer</td>
                <td style='border-top: solid; border-width: 1px;  text-align: right'>${payment.customerName}</td>
              </tr>
            `
        : ''}

      </tbody>
    </table>

    <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          <tr>
            <td><b>Product</b></td>
            <td style='text-align: right'><b>Qty</b></td>
            <td style='text-align: right'><b>Price</b></td>
          </tr>
          ${paymentLinesWithoutPaymentFees
        .map((paymentLine) => {
        let unitString;
        const loyaltyPointUsedByDiscountId = paymentLine.discountId && loyaltyData
            ? loyaltyData.mappedDiscountIdToAmount.get(paymentLine.discountId)
            : undefined;
        if (paymentLine.inventorySubtracted) {
            if (paymentLine.unit === 'gram') {
                unitString = `${paymentLine.inventorySubtracted} g`;
            }
            else {
                unitString = paymentLine.inventorySubtracted.toString();
            }
        }
        else {
            unitString = paymentLine.units.toString();
        }
        if (paymentLine.type === 'discount' || paymentLine.type === 'loyalty') {
            return `
                <tr>
                  <td style='border-top: solid; border-width: 1px;'>${paymentLine.productName}</td>
                  <td style='border-top: solid; border-width: 1px; text-align: right'></td>
                  <td style='border-top: solid; border-width: 1px; text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                </tr>

                ${receiptLoyalty
                ? (0, receiptLoyaltyHtml_1.renderRedeemedPointsRowHTML)(receiptLoyalty, paymentLine.id)
                : loyaltyPointUsedByDiscountId !== undefined
                    ? `
                  <tr>
                    <td colspan=3 style='text-align: right; word-break: keep-all;'>${loyaltyPointUsedByDiscountId.toLocaleString('en-CA')} Points</td>
                  </tr>
                  `
                    : ''}
                `;
        }
        return `
                <tr>
                  <td style='border-top: solid; border-width: 1px; '>
                    <div class='d-flex' style='flex-direction: column;'>
                      ${showSku && !!paymentLine.sku ? `<div>${paymentLine.sku}</div>` : ''}
                      <div>${paymentLine.productName}</div>
                      ${paymentLine.batchNumber ? `<div>Lot: ${paymentLine.batchNumber}</div>` : ''}
                      ${paymentLine.shortDescription
            ? `<div style='font-size: .9em'>${paymentLine.shortDescription}</div>`
            : ''}
                    </div>
                  </td>
                  <td style='border-top: solid; border-width: 1px; padding-right:.5rem; text-align: right'>${unitString}</td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.price)}</td>
                </tr>
                ${paymentLine.discountPrice
            ? `
                  <tr>
                    <td>${paymentLine.discountMessage}</td>
                    <td></td>
                    <td style='text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.discountPrice)}</td>
                  </tr>

                  ${receiptLoyalty === undefined && loyaltyPointUsedByDiscountId !== undefined
                ? `
                    <tr>
                      <td colspan=3 style='text-align: right; word-break: keep-all;'>${loyaltyPointUsedByDiscountId.toLocaleString('en-CA')} Points</td>
                    </tr>
                    `
                : ''}
                  `
            : ''}
                ${paymentLine.depositFee
            ? `
                  <tr>
                    <td>Deposit Fee</td>
                    <td></td>
                    <td style='text-align: right; word-break: keep-all;'>${(0, utils_1.formatCurrencyFromCents)(paymentLine.depositFee)}</td>
                  </tr>
                  `
            : ''}${receiptLoyalty ? (0, receiptLoyaltyHtml_1.renderRedeemedPointsRowHTML)(receiptLoyalty, paymentLine.id) : ''}
                `;
    })
        .join('')}
         </tbody>
        </table>

      ${paymentFeeLines.length > 0
        ? `
        <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
          <tbody>
            <tr>
              <td><b>Payment Fees</b></td>
              <td></td>
              <td></td>
            </tr>
            
            ${(0, utils_1.getAggregatedPaymentFees)(paymentFeeLines)
            .map((aggregatedFee) => `
                  <tr>
                    <td style='border-top: solid; border-width: 1px; '>${aggregatedFee.name}</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'></td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(aggregatedFee.totalAmount)}</td>
                  </tr>
                `)
            .join('')}
          </tbody>
        </table>
      `
        : ''}

      <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          <tr>
            <td style='width: 20%'></td>
            <td style='border-top: solid; border-width: 1px; '>Subtotal</td>
            <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(payment.subTotal)}</td>
          </tr>
          ${(0, lodash_1.chain)(payment.taxPaymentLines)
        .groupBy('taxId')
        .map((objs, key) => ({
        id: key,
        name: objs[0].displayName || objs[0].taxName,
        totalAmount: objs.reduce((prev, next) => prev + next.amount, 0),
    }))
        .value()
        .map((aggregatedTax) => `
                  <tr>
                    <td style='width: 20%'></td>
                    <td style='border-top: solid; border-width: 1px; '>${aggregatedTax.name}</td>
                    <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(aggregatedTax.totalAmount)}</td>
                  </tr>
                `)
        .join('')}
          ${totalDepositFee
        ? `
            <tr>
              <td style='width: 20%'></td>
              <td style='border-top: solid; border-width: 1px; '>Deposit Fee</td>
              <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(totalDepositFee)}</td>
            </tr>
            `
        : ''}
          ${payment.pennyAdjustment !== 0
        ? `
              <tr style='font-size: 1em; font-weight: 400;'>
                <td style='width: 20%'></td>
                <td style='border-top: solid; border-width: 1px; '>Penny adjustment</td>
                <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(payment.pennyAdjustment)}</td>
              </tr>
            `
        : ''}
          <tr style='font-weight: 600;'>
            <td style='width: 20%'></td>
            <td style='border-top: solid; border-width: 1px; '>Total</td>
            <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(payment.total + payment.pennyAdjustment)}</td>
          </tr>
        </tbody>
      </table>

      <table style='margin-top: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          ${payment.transactions
        .map((transaction) => {
        const monerisMetaData = (0, utils_1.getMonerisMetaDataFields)(transaction);
        const merrcoMetaData = (0, utils_1.getMerrcoMetaDataFields)(transaction);
        const worldpayMetaData = (0, utils_1.getWorldpayMetaDataFields)(transaction);
        const loyaltyMetaData = (0, utils_1.getLoyaltyMetaDataFields)(transaction);
        const paymentDisplayName = (paymentOptionNames === null || paymentOptionNames === void 0 ? void 0 : paymentOptionNames[transaction.paymentTypeId]) ||
            (0, utils_1.paymentNameFormatter)(transaction.paymentTypeId);
        return `
                <tr>
                  <td style='width: 20%'></td>
                  <td style='border-top: solid; border-width: 1px; '>
                    ${paymentDisplayName} - paid
                    ${homi_shared_1.PaymentTypeIds.merrco === transaction.paymentTypeId &&
            !!merrcoMetaData &&
            merrcoMetaData.emvLabel &&
            merrcoMetaData.cardNumber
            ? `
                            <span style="display: block;">EMV: ${merrcoMetaData.emvLabel}</span>
                            <span style="display: block;">Card: ${merrcoMetaData.cardNumber
                .split('X')
                .join('')}</span>
                          `
            : ''}
                    ${homi_shared_1.PaymentTypeIds.moneris === transaction.paymentTypeId && monerisMetaData
            ? `
                            <span style="display: block;">EMV: ${monerisMetaData.emvLabel}</span>
                            <span style="display: block;">Card: ${monerisMetaData.card}</span>
                          `
            : ''}
                    ${homi_shared_1.PaymentTypeIds.worldpay === transaction.paymentTypeId && worldpayMetaData
            ? `
                            <span style="display: block;">EMV: ${worldpayMetaData.cardLogo || ''}</span>
                            <span style="display: block;">Card: ${worldpayMetaData.accountNumber.slice(-4)}</span>
                          `
            : ''}
                    ${transaction.merrcoInvoiceId
            ? `<span style="display: block;">Auth #: ${transaction.merrcoInvoiceId}</span>`
            : ''}
                    ${transaction.terminalInvoiceId
            ? `<span style="display: block;">Auth #: ${transaction.terminalInvoiceId}</span>`
            : ''}
                    ${homi_shared_1.PaymentTypeIds.cash === transaction.paymentTypeId &&
            payment.pennyAdjustment !== 0
            ? `<span style="display: block;">Penny adj: ${(0, utils_1.formatCurrencyFromCents)(payment.pennyAdjustment)}</span>`
            : ''}
                    ${homi_shared_1.PaymentTypeIds.cash === transaction.paymentTypeId && change > 0
            ? `<span style="display: block;"><b>Change: ${(0, utils_1.formatCurrencyFromCents)(change)}</b></span>`
            : ''}
                    ${homi_shared_1.PaymentTypeIds.cash === transaction.paymentTypeId && payment.tendered > 0
            ? `<span style="display: block;">Tendered: ${(0, utils_1.formatCurrencyFromCents)(payment.tendered)}</span>`
            : ''}
                  </td>
                  <td style='border-top: solid; border-width: 1px;  text-align: right'>${(0, utils_1.formatCurrencyFromCents)(transaction.amount)}</td>
                </tr>
                
                ${homi_shared_1.PaymentTypeIds.loyalty === transaction.paymentTypeId
            ? (0, receiptLoyaltyHtml_1.renderTenderedPointsRowHTML)(receiptLoyalty, loyaltyData, loyaltyMetaData === null || loyaltyMetaData === void 0 ? void 0 : loyaltyMetaData.points, isRefundPayment)
            : ''}
              `;
    })
        .join('')}
          ${company.gstNumber
        ? `
              <tr>
                <td style='width: 20%'></td>
                <td style='border-top: solid; border-width: 1px; '>GST #</td>
                <td style='border-top: solid; border-width: 1px;  text-align: right'>${company.gstNumber}</td>
              </tr>
              `
        : ''}
        </tbody>
      </table>

      <table style='margin-top: 1.5rem; margin-bottom: 1.5rem; width: 100%; border: none; border-width: 0; border-collapse: collapse; padding: 0;${fontSize ? `font-size: ${fontSize};` : ''}'>
        <tbody>
          ${footer
        ? `
            <tr style='text-align: center;'>
              <td colspan=2 style='border-top: solid; border-width: 1px;  margin-bottom: 20px; white-space: pre-line; overflow-wrap: break-word; word-break: break-word'>${footer}</td>
            </tr>
            `
        : ''}

          ${receiptLoyalty
        ? (0, receiptLoyaltyHtml_1.renderReceiptLoyaltySectionHTML)(receiptLoyalty, isRefundPayment)
        : loyaltyData !== undefined &&
            loyaltyData.loyaltyEarned !== undefined &&
            loyaltyData.loyaltyEarned >= 0
            ? `
            <tr style='margin-top: 1.5rem; border-top: solid; border-width: 1px;'>
              <td>${isRefundPayment ? 'Loyalty Returned' : 'Loyalty Earned'}</td>
              <td colspan=2 style='text-align: right; white-space: nowrap;'>${loyaltyData.loyaltyEarned.toLocaleString('en-CA')} Points</td>
            </tr>
            `
            : ''}

          ${receiptLoyalty === undefined &&
        loyaltyData !== undefined &&
        loyaltyData.loyaltyReversed !== undefined
        ? `
            <tr style='margin-top: 1.5rem; border-top: solid; border-width: 1px;'>
              <td>Loyalty Reversed</td>
              <td colspan=2 style='text-align: right; white-space: nowrap;'>${loyaltyData.loyaltyReversed.toLocaleString('en-CA')} Points</td>
            </tr>
            `
        : ''}

          ${receiptLoyalty === undefined &&
        loyaltyData !== undefined &&
        loyaltyData.loyaltyBalance !== undefined
        ? `
            <tr style='margin-top: 1.5rem; border-top: solid; border-width: 1px;'>
              <td>Loyalty Balance</td>
              <td colspan=2 style='text-align: right; white-space: nowrap;'>${loyaltyData.loyaltyBalance.toLocaleString('en-CA')} Points</td>
            </tr>
            `
        : ''}
        </tbody>
      </table>
 
  </div>
  </div>
  `;
};
exports.generateReceiptHTMLV2 = generateReceiptHTMLV2;
//# sourceMappingURL=generateReceiptHTMLV2.js.map